export var AuthStrategy;
(function (AuthStrategy) {
    AuthStrategy["OKTA"] = "OKTA";
    AuthStrategy["MS"] = "MS";
})(AuthStrategy || (AuthStrategy = {}));
//# sourceMappingURL=auth.interfaces.js.map